var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchools(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/location/schools") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/location/schools",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#F2F2F2",
    points: "11 63 69 63 69 28 11 28"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#00ABE3",
    points: "13.9997 17.0001 10.9997 28.0001 68.9997 28.0001 65.9997 17.0001"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#667DBD",
    points: "33.5258 22.0146 27.5548 27.9856 33.5258 27.9856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9999,28.2499 C48.9999,33.2209 44.9709,37.2499 39.9999,37.2499 C35.0289,37.2499 30.9999,33.2209 30.9999,28.2499 C30.9999,23.2789 35.0289,19.2499 39.9999,19.2499 C44.9709,19.2499 48.9999,23.2789 48.9999,28.2499",
    id: "Fill-4",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,44 L24,36 L29,36 L29,44 L24,44 Z M24,57 L24,49 L29,49 L29,57 L24,57 Z M15,44 L15,36 L20,36 L20,44 L15,44 Z M15,57 L15,49 L20,49 L20,57 L15,57 Z M33,44 L33,36 L38,36 L38,44 L33,44 Z M33,63 L33,49 L47,49 L47,63 L33,63 Z M42,44 L42,36 L47,36 L47,44 L42,44 Z M51,44 L51,36 L56,36 L56,44 L51,44 Z M51,57 L51,49 L56,49 L56,57 L51,57 Z M60,44 L60,36 L65,36 L65,44 L60,44 Z M60,57 L60,49 L65,49 L65,57 L60,57 Z",
    id: "Combined-Shape",
    fill: "#313036"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fillOpacity: 0.25,
    fill: "#000000",
    points: "40.9999 27.1908 40.9999 21.9998 38.9999 21.9998 37.9999 22.9998 37.9999 29.3448 42.4999 31.9428 43.4999 30.9428 44.4999 29.2118"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#167EC4",
    points: "40.9999 27.1908 40.9999 21.9998 38.9999 21.9998 38.9999 28.3448 43.4999 30.9428 44.4999 29.2118"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#167EC4",
    points: "33 52 47 52 47 49 33 49"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchools);
export default __webpack_public_path__ + "static/media/schools.10fa07bdbafe6d3268ea3bce94944cbc.svg";
export { ForwardRef as ReactComponent };